import React, { useState, useEffect } from "react";
import "./ContactUs.css";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import ReCAPTCHA from "react-google-recaptcha";

export default function ContactUs() {
  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [messageErr, setMessageErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [capVal, setCapVal] = useState(null);

  const { user } = useAuthContext();

  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  const sendEnquiry = async () => {
    setIsLoading(true);
    setNameErr("");
    setEmailErr("");
    setMessageErr("");

    let err = false;

    if(capVal == null){
      err = true
    }

    if (name == "") {
      setNameErr("Name must be included.");
      err = true;
    }
    if (email == "") {
      setEmailErr("Email must be included.");
      err = true;
    }
    if (message == "") {
      setMessageErr("Message must be included.");
      err = true;
    }

    if (!err) {
      try {
        const contactUs = {
          name,
          email,
          phoneNumber,
          message,
        };

        const enquiryResponse = await axios.post(
          `${ApiConnectionString}/api/ContactUs`,
          contactUs,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (enquiryResponse.status === 200) {
          setComplete(true);
        }
      } catch (error) {
        // Handle the error here (e.g., display an error message)
        console.error("Error sending enquiry:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="container bg-white">
          <div className="contactUsContainer">
            <div className="contactUsBanner">
              <p className="p-2 fw-bold">Contact us</p>
            </div>
            <p className="mx-3 cu-custom-medium ">Enquiry Sent</p>
            <p className="mx-3">We will get back to you as soon as possble.</p>

            <p className="text-muted mx-3">
              We take your privacy seriously and will only use your personal
              information to contact you with regards to your enquiry. We will
              not use your information for marketing purposes.
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container bg-white pt-2">
          <div className="contactUsContainer">
            <div className="contactUsBanner">
              <p className="p-2 fw-bold">Contact us</p>
            </div>
            <p className="row mx-3">Leave a message for us.</p>

            <div className="row mx-2">
              {/* Left Column */}
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  {nameErr && <p className="text-danger">{nameErr}</p>}
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    required
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {emailErr && <p className="text-danger">{emailErr}</p>}
                </div>
                <div className="mb-3">
                  <label htmlFor="phoneNumber" className="form-label">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="phoneNumber"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
              </div>

              {/* Right Column */}
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="message" className="form-label">
                    Message
                  </label>
                  <textarea
                    required
                    className="form-control"
                    id="message"
                    rows="7"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  ></textarea>
                  {messageErr && <p className="text-danger">{messageErr}</p>}
                </div>
              </div>
            </div>
            <div className="m-3">
              <ReCAPTCHA
                sitekey="6LeXa0QqAAAAAOMfVHItB7SWzaKJZCQg0XeM6_d2"
                onChange={(val) => setCapVal(val)}
              />
            </div>

            {capVal ? (
              <button className="cu-red-button m-3" onClick={sendEnquiry}>
                <a className="fw-bold">Send Enquiry</a>
              </button>
            ) : (
              <button
                disabled={true}
                className="disableButton m-3"
                onClick={sendEnquiry}
              >
                <a className="fw-bold">Send Enquiry</a>
              </button>
            )}
            <p className="text-muted mx-3">
              We take your privacy seriously and will only use your personal
              information to contact you with regards to your enquiry. We will
              not use your information for marketing purposes.
            </p>
          </div>
        </div>
      );
    }
  }
}
